import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_equipment_serial_number_cell = _resolveComponent("equipment-serial-number-cell")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_software_version_cell = _resolveComponent("software-version-cell")!
  const _component_my_grid = _resolveComponent("my-grid")!
  const _component_lazy = _resolveComponent("lazy")!

  return (!_ctx.noEquipments)
    ? (_openBlock(), _createBlock(_component_lazy, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_my_grid, {
            data: _ctx.equipmentRows,
            columns: _ctx.columns,
            withHover: true,
            "initial-sort": [{ field: 'deliveryDate', dir: 'desc' }],
            state: () => _ctx.gridState,
            pageable: true,
            pageSize: 50,
            filterable: false,
            class: "flex-node-col"
          }, {
            customTemplate1: _withCtx(({props}) => [
              _createVNode(_component_equipment_serial_number_cell, {
                id: _ctx.getId(props.dataItem.serialNo),
                "data-item": props.dataItem,
                onClick: ($event: any) => (_ctx.redirectToDevice(props.dataItem.serialNo))
              }, null, 8, ["id", "data-item", "onClick"])
            ]),
            customTemplate2: _withCtx(({props}) => [
              _createVNode(_component_date_field, {
                value: props.dataItem[props.field],
                format: "date"
              }, null, 8, ["value"]),
              (_ctx.isFutureDate(props.dataItem[props.field]))
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, " (" + _toDisplayString(_ctx.localize('planned')) + ")", 1))
                : _createCommentVNode("", true)
            ]),
            customTemplate3: _withCtx(({props}) => [
              _createVNode(_component_software_version_cell, {
                row: props.dataItem
              }, null, 8, ["row"])
            ]),
            _: 1
          }, 8, ["data", "columns", "state"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}